import { useLayoutEffect, useRef, useState } from 'react'

export const useIsOverflowingOneLine = (dependencies: any[] = []) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    if (el) {
      const isOverflowing = el.scrollHeight > el.offsetHeight
      setIsOverflowing(isOverflowing)
    }
  }, dependencies)

  return [isOverflowing, ref] as const
}
